(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/bankid/assets/javascripts/checker.js') >= 0) return;  svs.modules.push('/components/app/bankid/assets/javascripts/checker.js'); (function(svs) {
  svs.app.bankid.Checker = function(options) {
    this.model = new Backbone.Model({
      error: false,
      progressStatus: 1,
      progressText: 'Försöker starta BankID-appen'
    });
    this.autoStartToken = options.autoStartToken;
    var logger = svs.core.log.getLogger('app:bankid:Checker'),
      stopPolling = false,
      errorHandler = function(xhr) {
        var errorCode =
          xhr &&
          xhr.responseJSON &&
          xhr.responseJSON.error &&
          xhr.responseJSON.error.code;
        if (errorCode && errorCode === 666 && this.errorRetries > 0) {
          this.errorRetries = this.errorRetries - 1;
          logger.info('Received network error when doing bankid signing, retrying bankid. Retries left: ' + this.errorRetries);
          setTimeout(checker.bind(this), 1000);
        } else {
          this.model.set({ error: xhr });
        }
      },
      successFn = function(resp) {
        var progressText = 'Starta din BankID-app';
        if (resp.postToken) {
          logger.debug('postToken: ' + resp.postToken);
          this.model.set('postToken', resp.postToken);
        } else if (resp.progressStatus) {
          logger.debug('progressStatus: ' + resp.progressStatus);
          switch (resp.progressStatus) {
            case 0:
            case 1:
            case 2:
              progressText = 'Försöker starta BankID-appen';
              break;
            case 3:
              progressText = 'Söker efter BankID, det kan ta en liten stund.';
              break;
            case 4:
            case 5:
            case 6:
              progressText =
                'Skriv in din säkerhetskod i BankID-appen och välj Legitimera eller Skriv under.';
              break;
            default:
              logger.warn('Unhandle progress status: ' + resp.progressStatus);
          }
          this.model.set({
            progressStatus: resp.progessStatus,
            progressText: progressText
          });
          if (!stopPolling) {
            setTimeout(checker.bind(this), 1000);
          }
        }
      },
      checker = function() {
        svs.core.jupiter.call(
          {
            path: '/player/authenticatesign/verify',
            method: 'POST',
            data: {
              autoStartToken: this.autoStartToken
            },
            context: this
          },
          successFn,
          errorHandler
        );
      };
    this.startPolling = function() {
      this.errorRetries = 3;
      checker.call(this);
    };
    this.stopPolling = function() {
      stopPolling = true;
    };
  };
})(svs);

 })(window);